var DwAgGridValidationEditorComponent = /** @class */ (function () {
    function DwAgGridValidationEditorComponent() {
        this.editType = '';
        this.validationMessages = [];
        this._errorVisible = false;
        this.overlayStyle = {
            color: 'red'
        };
    }
    DwAgGridValidationEditorComponent.prototype.onMouseOver = function () {
        this.errorVisible = true;
    };
    DwAgGridValidationEditorComponent.prototype.onMouseOut = function () {
        this.errorVisible = false;
    };
    Object.defineProperty(DwAgGridValidationEditorComponent.prototype, "errorVisible", {
        get: function () {
            return this.validationMessages.length > 0 && this._errorVisible;
        },
        set: function (visible) {
            this._errorVisible = visible;
        },
        enumerable: true,
        configurable: true
    });
    DwAgGridValidationEditorComponent.prototype.init = function () {
        var _this = this;
        if (this.formControl) {
            this.formControl.statusChanges.subscribe(function (data) { return _this.updateValidateStatus(data); });
        }
    };
    DwAgGridValidationEditorComponent.prototype.updateValidateStatus = function (status) {
        var errors = this.formControl.errors;
        var errorKeys = [];
        // this.validateStatus = status;
        // const errorKeys = [];
        // const errors = this.control.errors;
        /* tslint:disable-next-line: forin */
        for (var key in errors) {
            var error = errors[key];
            errorKeys.push({
                key: key,
                params: error
            });
        }
        this.validationMessages = errorKeys;
    };
    DwAgGridValidationEditorComponent.prototype.isFullRowEdit = function () {
        return this.editType === 'fullRow';
    };
    return DwAgGridValidationEditorComponent;
}());
export { DwAgGridValidationEditorComponent };
